import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, InputNumber, Row, Select, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useState } from "react";
import Dropzone from "react-dropzone";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;
const { Option } = Select;

const productCategoryOptions = [
  { label: "POSM", value: "posm" },
  { label: "Assets", value: "asset" },
];

const AddProduct = () => {
  const navigate = useNavigate();
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  // Form states
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]); // Files from Dropzone

  // For preview images base64 or object URL if needed
  const [previews, setPreviews] = useState([]);

  const handleAcceptedFiles = (files) => {
    setSelectedFiles(files);

    // Generate previews for UI
    const previewsArr = files.map((file) => {
      return Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
    });
    setPreviews(previewsArr);
  };

  const validateForm = () => {
    if (!productName || quantity <= 0 || price <= 0 || !productCategory) {
      message.warning("Please fill all required fields");
      return false;
    }
    if (selectedFiles.length === 0) {
      message.warning("Please upload at least one product image");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      const formData = new FormData();

      // Append images
      selectedFiles.forEach((file) => {
        formData.append("images", file);
      });

      // Append other fields
      formData.append("productName", productName);
      formData.append("quantity", quantity);
      formData.append("price", price);
      formData.append("productDescription", description);
      formData.append("productCategory", productCategory);
      formData.append("inStock", true);


      // Send POST request
      await axios.post(`${process.env.REACT_APP_API_BASEURL}/product`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("Product added successfully");
      navigate("/products");
    } catch (error) {
      console.error("Failed to add product:", error);
      message.error("Failed to add product. Please try again.");
    }
  };

  return (

    <div className="p-4">
      <Card title="Add Product">
        <Row gutter={16}>
          <Col span={8}>
            <Text strong>Product Name</Text>
            <Input value={productName} onChange={(e) => setProductName(e.target.value)} />
          </Col>
          <Col span={8}>
            <Text strong>Quantity</Text>
            <InputNumber
              min={1}
              value={quantity}
              onChange={setQuantity}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={8}>
            <Text strong>Price</Text>
            <InputNumber
              min={1}
              value={price}
              onChange={setPrice}
              style={{ width: "100%" }}
              prefix="₹"
            />
          </Col>
        </Row>

        <Row gutter={16} style={{ marginTop: 20 }}>
          <Col span={12}>
            <Text strong>Description</Text>
            <Input.TextArea
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Col>
          <Col span={12}>
            <Text strong>Product Category</Text>
            <Select
              showSearch
              value={productCategory}
              onChange={setProductCategory}
              style={{ width: "100%" }}
              placeholder="Select Category"
            >
              {productCategoryOptions.map((cat) => (
                <Option key={cat.value} value={cat.value}>
                  {cat.label}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        <Row style={{ marginTop: 20, marginBottom: 30 }}>
          <Col span={24}>
            <Text strong>Product Images</Text>

            <Dropzone onDrop={handleAcceptedFiles} accept={{ "image/*": [] }} multiple>
              {({ getRootProps, getInputProps }) => (
                <div
                  {...getRootProps()}
                  style={{
                    border: "2px dashed #d9d9d9",
                    padding: "30px",
                    textAlign: "center",
                    cursor: "pointer",
                    borderRadius: "4px",
                  }}
                >
                  <input {...getInputProps()} />
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/1828/1828491.png"
                    alt="Upload"
                    style={{ width: "40px", marginBottom: "10px", opacity: 0.5 }}
                  />
                  <p>Drag & drop images here, or click to select files</p>
                </div>
              )}

            </Dropzone>

            <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
              {previews.map((file, idx) => (
                <Col key={idx} span={4}>
                  <Card
                    cover={
                      <img
                        src={file.preview}
                        alt={`Preview ${idx}`}
                        style={{ height: 100, objectFit: "cover" }}
                        onLoad={() => URL.revokeObjectURL(file.preview)}
                      />
                    }
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        <Row justify="start" style={{ marginTop: 20 }}>
          <Button
            type="primary"
            onClick={handleSubmit}
            icon={<PlusOutlined />}
            style={{
              backgroundColor: PRIMARY_RED,
              borderColor: PRIMARY_RED,
              marginRight: 12,
            }}
          >
            Add Product
          </Button>
          <Button type="link" style={{ color: PRIMARY_RED }} icon={<ArrowLeftOutlined />} onClick={() => navigate("/products")}>
            Back
          </Button>
        </Row>
      </Card>
    </div>
  );
};

export default AddProduct;
